// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2FTE7","unreadBadge":"styles_unreadBadge__1-tfE","modalContent":"styles_modalContent__rkZ2r","modal":"styles_modal__1x6T1"};